import { getTime, format } from 'date-fns'
import { ru } from 'date-fns/esm/locale'
import i18n from '../i18n'
import { FILE_D, httpOk } from './api';
import { store } from '../store/index'

export const uploadUrl = "https://backend.tameer.uz/uploads";

export const roles = [
	{
		id: 'technologist',
		name: i18n.t('technologist')
	},
	{
		id: 'warehouse_raw',
		name: i18n.t('warehouse_raw'),
		warehouseType: 'raw',
	},
	{
		id: 'warehouse_finished',
		name: i18n.t('warehouse_finished'),
		warehouseType: 'finished',
	},
	{
		id: 'sales',
		name: i18n.t('sales')
	},
	{
		id: 'production',
		name: i18n.t('production'),
		warehouseType: 'production',
	},
	{
		id: 'management',
		name: i18n.t('management')
	},
	{
		id: 'procurement',
		name: i18n.t('procurement'),
	},
];

export const sources = [
	{
		id: 'telegram',
		name: i18n.t('telegram'),
	},
	{
		id: 'manager',
		name: i18n.t('manager'),
	},
	{
		id: 'api',
		name: i18n.t('api'),
	},
	{
		id: 'other',
		name: i18n.t('other'),
	},
]


export function regexLogin(str) {
	if (str) {
		return str.toLowerCase().replace(/[^a-z0-9_]/gi, '');
	}
	return ''
}

export function deleteSymbols(str) {
	if (str) {
		return str.replace(/[^A-Z0-9]/gi, '');
	}
	return ''
}

export function regexNumeric(str) {
	if (str) {
		return str.replace(/[^0-9.]/gi, '');
	}
	return ''
}

export function returnSign(str) {
	return str.includes('?') ? '&' : '?'
}

export function arrayJoin(arr, arrayOfObjects = true) {
	if (arrayOfObjects) {
		return arr.map(u => u.id).join(',')
	}

	return arr.join()
}

export function returnMonth(number) {
	const dates = [
		{ 'id': 1, 'name': i18n.t('january') },
		{ 'id': 2, 'name': i18n.t('february') },
		{ 'id': 3, 'name': i18n.t('march') },
		{ 'id': 4, 'name': i18n.t('april') },
		{ 'id': 5, 'name': i18n.t('may') },
		{ 'id': 6, 'name': i18n.t('june') },
		{ 'id': 7, 'name': i18n.t('july') },
		{ 'id': 8, 'name': i18n.t('august') },
		{ 'id': 9, 'name': i18n.t('september') },
		{ 'id': 10, 'name': i18n.t('october') },
		{ 'id': 11, 'name': i18n.t('november') },
		{ 'id': 12, 'name': i18n.t('december') },
	]
	if (number) {
		return dates.find(item => item.id === number)['name']
	} else {
		return ''
	}
}

export function regexPhoneNumber(str) {
	if (str) {
		return str.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/, "$1$2 $3-$4-$5");
	}
	return ""
}

export function clearTemporaryStorage() {
	localStorage.removeItem('login')
	localStorage.removeItem('role')
	localStorage.removeItem('token')
}

export function findKeyFromArrayByValue(array, valueName, value, key) {
	if ((array.length > 0 && value) || value === 0) {
		var found = array.find(x => x[valueName] === value)
		return found ? found[key] : '';
	}
}

export function formatMoneyInput(amount) {
	if (!amount) return "";
	let cleaned = amount?.toString()?.replace(/[^\d.]/g, '');
	const [integerPart, decimalPart] = cleaned.split(".");
	const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
}

export function formatMoney(amount, maxDecimal = 3, decimal = ".", thousands = " ") {
	if (!amount) {
		return "0";
	}

	const num = Number(amount);
	if (isNaN(num)) {
		return "0";
	}

	const negativeSign = num < 0 ? "-" : "";
	const absNum = Math.abs(num);

	const [intPart, fracPart = ""] = absNum.toString().split(".");

	const trimmedFrac = fracPart.length > maxDecimal
		? fracPart.slice(0, maxDecimal)
		: fracPart;

	const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

	return negativeSign
		+ formattedInt
		+ (trimmedFrac ? decimal + trimmedFrac : "");
}

export function formatDate(date, formating = 'dd.MM.yyyy') {
	if (date) {
		var formattedDate = format(new Date(date), formating);
		return formattedDate
	}
}

export function newDate(format = 'yyyy-MM-dd') {
	return format(new Date(), format)
}

export function formatDateCalendar(date) {
	if (date) {
		var formattedDate = format(new Date(date), 'dd MMMM yyyy', { locale: ru });
		return formattedDate
	}
}

export function getUnixTime() {
	return getTime(new Date())
}

export function getUnixTimeByDate(date) {
	return getTime(date)
}

export function formatUnixTime(unixTime) {
	if (unixTime)
		return format(new Date(unixTime), 'dd.MM.yyyy HH:mm:ss')
}

export function sumFromArray(array, key) {
	var sum = 0
	if (array && array.length > 0) {
		for (let i = 0; i < array.length; i++) {
			sum += Number(array[i][key]);
		}
	}

	return sum
}

export function returnMinDate(date, days) {
	var result = new Date(date);
	result.setDate(result.getDate() - days);
	return result;
}

export function countTotalFromArray(array = [], key) {
	var count = 0

	if (array?.length > 0) {
		for (let i = 0; i < array.length; i++) {
			count += Number(array[i][key])
		}
	}
	return count
}

export function generateTransactionId(posId, userId) {
	if (posId && userId)
		return posId.toString() + userId.toString() + getUnixTime().toString() + Math.floor(Math.random() * 999999)
}

export function copyText(text) {
	navigator.clipboard.writeText(text)
}

export const chequeDates = [
	{ 'id': 'today', 'name': i18n.t('today') },
	{ 'id': 'currentWeek', 'name': i18n.t('current_week') },
	{ 'id': 'currentMonth', 'name': i18n.t('current_month') },
	{ 'id': 'currentYear', 'name': i18n.t('current_year') },
	{ 'id': 'yesterday', 'name': i18n.t('yesterday') },
	{ 'id': 'lastWeek', 'name': i18n.t('last_week') },
	{ 'id': 'lastMonth', 'name': i18n.t('last_month') },
	{ 'id': 'lastYear', 'name': i18n.t('last_year') },
	// { 'id': 'other', 'name': i18n.t('other') }, // Для "Другой..."
];


export function getCurrentChequeDate(type) {
	const today = new Date();
	let newStartDate = null;
	let newEndDate = null;

	const getStartOfWeek = (date) => {
		const d = new Date(date);
		const day = d.getDay();
		const diff = d.getDate() - day + (day === 0 ? -6 : 1);
		return new Date(d.setDate(diff));
	};

	const getEndOfWeek = (date) => {
		const d = new Date(date);
		const startOfWeek = getStartOfWeek(d);
		const endOfWeek = new Date(startOfWeek);
		endOfWeek.setDate(startOfWeek.getDate() + 6);
		return endOfWeek;
	};

	switch (type) {
		case 'today':
			newStartDate = formatDate(today, 'yyyy-MM-dd');
			newEndDate = formatDate(today, 'yyyy-MM-dd');
			break;
		case 'currentWeek':
			const startOfCurrentWeek = getStartOfWeek(today);
			const endOfCurrentWeek = getEndOfWeek(today);
			newStartDate = formatDate(startOfCurrentWeek, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfCurrentWeek, 'yyyy-MM-dd');
			break;
		case 'currentMonth':
			const startOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
			const endOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
			newStartDate = formatDate(startOfCurrentMonth, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfCurrentMonth, 'yyyy-MM-dd');
			break;
		case 'currentYear':
			const startOfCurrentYear = new Date(today.getFullYear(), 0, 1);
			const endOfCurrentYear = new Date(today.getFullYear(), 11, 31);
			newStartDate = formatDate(startOfCurrentYear, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfCurrentYear, 'yyyy-MM-dd');
			break;
		case 'yesterday':
			const yesterday = new Date(today);
			yesterday.setDate(today.getDate() - 1);
			newStartDate = formatDate(yesterday, 'yyyy-MM-dd');
			newEndDate = formatDate(yesterday, 'yyyy-MM-dd');
			break;
		case 'lastWeek':
			const lastWeekEnd = new Date(today);
			lastWeekEnd.setDate(today.getDate() - 7);
			const startOfLastWeek = getStartOfWeek(lastWeekEnd);
			const endOfLastWeek = getEndOfWeek(lastWeekEnd);
			newStartDate = formatDate(startOfLastWeek, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfLastWeek, 'yyyy-MM-dd');
			break;
		case 'lastMonth':
			const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
			const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
			newStartDate = formatDate(startOfLastMonth, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfLastMonth, 'yyyy-MM-dd');
			break;
		case 'lastYear':
			const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
			const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
			newStartDate = formatDate(startOfLastYear, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfLastYear, 'yyyy-MM-dd');
			break;
		default:
			newStartDate = null;
			newEndDate = null;
			break;
	}

	return {
		start_date: newStartDate,
		end_date: newEndDate,
	}
}

export async function checkFilter(filterData = {}, initialFilter = {},) {
	let hasFilter = false;
	for (const key in filterData) {
		if (filterData[key] !== initialFilter[key]) {
			hasFilter = true;
			break;
		}
	}
	return hasFilter;
};

export async function DOWNLOAD_FILE(url, filterData, name) {
	const response = await FILE_D(url, filterData)
	if (httpOk(response)) {
		const href = URL.createObjectURL(response.data);
		const link = document.createElement('a');
		link.href = href;
		link.setAttribute('download', name + '.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(href);
	}
}

export const getTodayDate = () => {
	return new Date().toISOString().split('T')[0]; // Результат: "2026-01-21"
};

export const handleDateChange = (date, fieldName, filterData) => {
	const formattedDate = date ? date.toISOString().split('T')[0] : '';
	return {
		...filterData,
		[fieldName]: formattedDate
	}
};

export function checkPermission(permission) {
	const roles = store.getState()?.account.permissions;
	var item = roles?.find(item => item.code === permission)
	if (item?.code?.length > 0) return true
	return false;
}